module.exports = __webpack_public_path__ + "img/a8c36e6.png";